import { render, staticRenderFns } from "./BaseClienteFactura.vue?vue&type=template&id=64f26ce0&"
import script from "./BaseClienteFactura.vue?vue&type=script&lang=js&"
export * from "./BaseClienteFactura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports